import { useEffect, useRef } from "react";

export function ApiDocsPage() {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function renderDocs() {
      const [{ default: SwaggerUIBundle }] = await Promise.all([
        import("swagger-ui-dist/swagger-ui-bundle.js"),
        import("swagger-ui-dist/swagger-ui.css"),
      ]);

      if (cancelled || !containerRef.current) return;

      containerRef.current.innerHTML = "";
      SwaggerUIBundle({
        domNode: containerRef.current,
        url: "/api/v1/system/openapi?include_plugins=true",
        deepLinking: true,
        displayOperationId: true,
        persistAuthorization: true,
        tryItOutEnabled: true,
        requestInterceptor: (request) => {
          request.credentials = "same-origin";
          return request;
        },
      });
    }

    void renderDocs();

    const container = containerRef.current;
    return () => {
      cancelled = true;
      if (container) {
        container.innerHTML = "";
      }
    };
  }, []);

  return (
    <div className="api-docs-page">
      <div className="page-header">
        <div>
          <h1>API Docs</h1>
          <p className="page-header-help api-docs-help">
            Interactive OpenAPI explorer for the running KnotFin API.
          </p>
        </div>
        <div className="page-header-actions">
          <a className="action-btn" href="/api/v1/system/openapi?include_plugins=true" target="_blank" rel="noreferrer">
            Open JSON
          </a>
        </div>
      </div>
      <div className="api-docs-frame" ref={containerRef}>
        <div className="page-loading">Loading API explorer...</div>
      </div>
    </div>
  );
}
